module.exports = "pegasus_template/assets/blocks/column-11-theme5.png";